var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/forgot-password.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0f26753b!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/forgot-password.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword.vue
// module id = 1313
// module chunks = 1